import * as React from "react";
import { RadioOrCheckListField } from "../../../../components/editors";
import { ModalForm } from "../../../../components/modal";
import { ComponentWithValidatedForm, ValidatedForm } from "../../../../components/validation";
import * as Forms from "../../../../forms";
import { SelectItem } from "../../../../models/editors";
import { TypeDefinition } from "../../../../models/generic";
import { Api } from "../../../../services/Api";

interface OwnProps {
    api: Api;
    onError?: (error: string) => void;
    onProcessing?: () => void;
    onUpdated?: (updatedAbstractIds: number[], selectedId?: number) => void;
}

interface OwnState {
    selectedAbstractIds: number[];
    show: boolean;
    statusItems: TypeDefinition[];
}

export class UpdateStatusModal extends ComponentWithValidatedForm<OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);

        const formModel = new Forms.AdminAbstract.AbstractsStatusUpdate();
        this.state = {
            ...this.getInitialState(formModel),
            selectedAbstractIds: [],
            show: false,
            statusItems: [],
        };

        this.onSubmit = this.onSubmit.bind(this);
    }

    public close() {
        this.setState({ ...this.state, show: false });
    }

    public show(statusItems: TypeDefinition[], selectedAbstractIds: number[]) {
        const formModel = new Forms.AdminAbstract.AbstractsStatusUpdate();
        this.setState({ ...this.state,
            ...this.getInitialState(formModel),
            selectedAbstractIds,
            show: true,
            statusItems,
        });
    }

    public async onSubmit(model: Forms.AdminAbstract.AbstractsStatusUpdateData) {
        this.toggleProcessing(true);

        const updateResult = await this.props.api.put<any>(Api.endpoints.admin.abstract.abstractStatus, {
            body: JSON.stringify({
                abstractIds: this.state.selectedAbstractIds,
                statusId: model.statusId,
            }),
        });

        if (updateResult.isSuccess && updateResult.data) {
            if (this.props.onUpdated)
                this.props.onUpdated(this.state.selectedAbstractIds, model.statusId);
            this.close();
        }
        else {
            if (this.props.onError)
                this.props.onError(updateResult.errors.join("; "));

            this.setFormErrors(updateResult.errors.length ? updateResult.errors : [updateResult.message || "Server error"]);
        }

        this.toggleProcessing(false);
    }

    public render() {
        const radioItems: SelectItem[] = this.state.statusItems.map((item) => {
            const selectItem: SelectItem = {
                selected: false,
                id: item.id,
                render: item.name,
            };
            return selectItem;
        });

        return <ModalForm formComponent={this} onCancel={() => this.close()} processing={this.state.formProcessing} show={this.state.show} title="Update abstract status">
            <p>Update the status of {this.state.selectedAbstractIds.length} selected abstract{this.state.selectedAbstractIds.length === 1 ? "" : "s"} to one of the following:</p>

            <ValidatedForm
                formComponent={this}
                model={this.state.formModel.data}
                onValidSubmit={this.onSubmit}
                schema={this.state.formModel.rules}
                ref={(ref: any) => this.form = ref}
            >

                <RadioOrCheckListField formComponent={this} items={radioItems} name="statusId" type="radio" />

            </ValidatedForm>
        </ModalForm>;
    }
}



// WEBPACK FOOTER //
// ./src/containers/adminAbstracts/list/components/UpdateStatusModal.tsx